<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10 device-binding">
        <el-row>
            <el-col :span="4">
                <item-input type="scan" v-model="scan_val" placeholder="请扫设备条码" :autofocus="true" @input="scanDevice()"></item-input>
            </el-col>
            <el-col :span="20" class="align-right padding5">
                <span class="fg-info"
                    >进手术间：&nbsp;<b>{{ this.surgeryBegin }}</b></span
                >&nbsp;&nbsp;
                <span class="fg-info"
                    >出手术间：&nbsp;<b>{{ this.surgeryEnd }}</b></span
                >&nbsp;&nbsp;
                <span class="fg-info"
                    >手术总时长:&nbsp;<b>{{ this.surgeryTotal }}</b></span
                >
            </el-col>
        </el-row>

        <el-row class="align-left" :style="{ 'min-height': `${this.screenHeight - 200}px` }">
            <el-col :xl="4" :md="6">
                <div v-for="g in unBindingDevice" :key="g.value" class="line-height30">
                    <h1>
                        {{ g.label }}<span class="fg-info">({{ (g.devices && g.devices.length) || 0 }})</span>
                    </h1>
                    <template v-if="g.devices && g.devices.length > 0">
                        <div v-for="d in g.devices" :key="d.id" class="device-item">
                            {{ d.name }}&nbsp;{{ d.device_no && `(${d.device_no})` }}
                            <span class="el-icon-plus cus-button is-circle" style="float: right" @click="useDevice(d)"></span>
                        </div>
                    </template>
                    <span class="fg-info" v-else>暂无设备</span>
                </div>
            </el-col>
            <el-col :xl="20" :md="18" class="padding20">
                <el-row>
                    <el-col :xl="8" :md="24" v-for="rb in usedDevice" :key="rb.id" class="padding10">
                        <el-card>
                            <div slot="header" class="header line-height20">
                                <el-row class="card-header" style="line-height: 20px">
                                    <el-col :span="16"
                                        ><div class="ellipsis">
                                            <b>{{ rb.device.name }}</b>
                                        </div></el-col
                                    >
                                    <el-col :span="8" class="align-right">
                                        <span class="cus-button is-circle el-icon-edit fg-danger" title="编辑" @click="editDevice(rb)"></span>
                                        <span class="cus-button is-circle el-icon-question" title="设备使用说明" v-if="rb.fs && rb.fs.pdf" @click="loadInstruction(rb)"></span>
                                        <span class="cus-button is-circle el-icon-delete fg-danger" title="移除设备" @click="remove(rb)"></span>
                                    </el-col>
                                </el-row>
                            </div>
                            <img
                                style="height: 200px; width: 100%; margin: 0 auto; display: block"
                                :src="(rb.fs && rb.fs.image && surgeryId && `${$root.BASE_URL}/api/AcisSystem/Device/GetPictureFile/${rb.dic_device_id}?fileName=${rb.fs.image[0]}`) || defaultimg"
                                :alt="rb.fs && rb.fs.image && rb.fs.image[0]"
                            />
                            <div class="font-size12 padding10 align-left" style="float: left">设备总时长{{ rb.use_time_hour }}时/{{ rb.use_time_minutes }}分</div>
                            <div class="font-size12 padding10 align-right">操作人：{{ rb.modifier }}&nbsp;&nbsp;{{ $moment(rb.modify_date).format('YYYY/MM/DD HH:mm') }}</div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <cus-dialog title="使用说明" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false" @confirm="dialogVisible = false">
            <div v-loading="loading" style="min-height: 580px">
                <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            </div>
        </cus-dialog>
        <UseDeviceDetail :visible.sync="useDeviceDetail.dialogFormVisible" :data="useDeviceDetail.data" @save-success="saveAsSuccess"></UseDeviceDetail>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import UseDeviceDetail from './UseDeviceDetail.vue'
import pdf from '@/common/vue-pdf-4.1.0'
export default {
    name: `SurgeryDevice`,
    components: { pdf, UseDeviceDetail },
    props: {

    },
    data() {
        return {
            title: `随身设备`,
            useDeviceDetail: {
                dialogFormVisible: false,
                data: {}
            },
            surgeryId: this.$route.query.surgery_id,
            unBindingDevice: [],
            scan_val: ``,
            surgeryInfo: {},
            usedDevice: [],
            allDevice: [],
            dialogVisible: false,
            src: ``,
            numPages: 0,
            loading: false,
            defaultimg: `static/img/defaultImg.jpg`
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `screenHeight`, `active_ward`]),
        surgeryBegin() {
            return this.surgeryInfo && this.surgeryInfo.in_room && this.$moment(this.surgeryInfo.in_room).format(`MM/DD HH:mm`) || `--`
        },
        surgeryEnd() {
            return this.surgeryInfo && this.surgeryInfo.enum_surgery_status >= 40 && this.$moment(this.surgeryInfo.out_room).format(`MM/DD HH:mm`) || `--`
        },
        surgeryTotal() {
            let t1 = this.surgeryInfo && this.surgeryInfo.in_room && this.$moment(this.surgeryInfo.in_room)
            let t2 = this.surgeryInfo && this.surgeryInfo.enum_surgery_status >= 40 && this.$moment(this.surgeryInfo.out_room)
            if (t1 && t2) {
                let ms = t2.diff(t1, `seconds`, true)
                // if(ms<60){
                //   return `${ms} s`
                // }else if(ms<3600){
                //   return `${Math.floor(ms/60)} min ${ms%60} s`
                // }else{
                //   return `${Math.floor(ms/3600)} h ${Math.floor(ms%3600/60)} min`
                // }
                return `${Math.floor(ms / 3600)} h ${Math.floor(ms % 3600 / 60)} min`
            }
            return `--`
        }
    },
    mounted() {
        this.loadSurgery()
        this.init()
    },
    methods: {
        loadSurgery() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            req.then(data => {
                this.surgeryInfo = data
            }).catch(e => console.log(e))
        },
        init() {
            if (!this.surgeryId) { return }
            let req1 = this.myaxios.get(`/api/AcisSystem/Device/Get`)
            let req2 = this.myaxios.get(`/api/Nursing/UseDevice/Get?surgeryId=${this.surgeryId}`)
            this.myaxios.all(req1, req2).then(([allDevice, used]) => {
                allDevice = _.filter(allDevice, d => { return `ow_${d.dic_operating_ward_id}` == this.active_ward.value || `rw_${d.dic_recovery_ward_id}` == this.active_ward.value })
                let unused = _.differenceWith(allDevice, used, function(ath, oth) {
                    return ath.id == oth.dic_device_id
                })
                let g = _.groupBy(unused, `type_no`)
                this.unBindingDevice = _.map(this.sys_enums.Enum_PhysioParamCategory, d => {
                    d.devices = g[d.value]
                    return d
                })
                this.allDevice = allDevice
                console.log(used)
                this.usedDevice = used
                let reqs = _.map(this.usedDevice, d => {
                    return this.myaxios.get(`/api/AcisSystem/Device/GetFileNames/${d.dic_device_id}`)
                })
                this.myaxios.all(...reqs).then((data) => {
                    _.forEach(data, (d2, index) => {
                        let fs = _.groupBy(d2, d3 => {
                            return d3.indexOf(`.pdf`) == -1 ? `image` : `pdf`
                        })
                        let r = this.usedDevice[index]
                        r.fs = fs
                        this.$set(this.usedDevice, index, r)
                    })
                })
            })
        },
        useDevice(d) {
            let req = this.myaxios.post(`/api/Nursing/UseDevice/Post`, {
                biz_surgery_info_id: this.surgeryId,
                dic_device_id: d.id
            })
            req.then(() => {
                this.init()
            }).catch(e => {
                console.log(e)
            })
        },
        scanDevice() {
            console.log(this.allDevice)
            let dv = _.find(this.allDevice, d => d.bar_code == this.scan_val || d.description == this.scan_val || d.serial_number == this.scan_val)
            // let used_dv =_.find(this.usedDevice,d=>d.dic_device_id ==this.scan_val)
            if (!dv) {
                this.$message.warning(`未找到该设备`)
                return
            }
            // if(used_dv){
            //   this.$message.warning("设备已被使用")
            //   return
            // }
            this.useDevice(dv)
        },
        loadInstruction(dv) {
            let src = dv.fs && dv.fs.pdf && this.surgeryId && `${this.$root.BASE_URL}api/AcisSystem/Device/GetPdfFile/${dv.dic_device_id}?fileName=${dv.fs.pdf[0]}`
            if (!src) { return }
            this.loading = true
            this.dialogVisible = true
            this.numPages = 0
            this.src = ``
            let req = this.myaxios.get(src)
            req.then(data => {
                this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                this.src.then(content => {
                    this.numPages = content.numPages
                    this.loading = false
                })
            }).catch(e => {
                console.log(e)
                this.loading = false
            })
        },
        remove(dv) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/Nursing/UseDevice/Delete/${dv.id}`)
                req.then(() => {
                    this.$message.success(`删除成功`)
                    this.init()
                })
            })
        },
        editDevice(dv) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/Nursing/UseDevice/Items/${dv.id}`)
                req.then(data => {
                    console.log(123)
                    console.log(data)
                    var ss = {}
                    ss.name = dv.device.name
                    ss.biz_use_device_id = dv.id
                    data.forEach(d => {
                        d.dic_worker_id = {
                            label: d.dic_worker_name,
                            value: d.dic_worker_id
                        }
                    })
                    ss.items = data
                    this.useDeviceDetail.dialogFormVisible = true
                    this.useDeviceDetail.data = ss
                    console.log(dv)
                    console.log(this.useDeviceDetail.data)
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        saveAsSuccess() {
            this.init()
        }

    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSurgery()
            this.init()
        },
        'active_ward': function() {
            this.loadSurgery()
            this.init()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Device/Index.vue